import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SetDataScryfall } from '../app/setData';
import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs/operators';
import { __values } from 'tslib';

@Injectable({
  providedIn: 'root'
})

export class GetSetsService {

  private setURl = 'https://api.scryfall.com/sets';

  constructor(private http: HttpClient) { }

  getSets(): Observable<any> {
    return this.http.get(this.setURl);
  }

}
